module.exports = __webpack_public_path__ + "static/img/logo-ifacare-white.a899f00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-ifacare-white.png
// module id = M0eZ
// module chunks = 39